<template>
  <div pr-split-left :class="[
    type,
    bottomFree ? 'bottom-free' : '',
    overflowTitle ? 'split-title-hide' : '',
  ]">
    <div class="bg" v-if="img" :style="{
      backgroundImage: img ? `url('${img}')` : 'none',
      marginRight: `${pv * 50}%`,
      width: `${(1 - pv) * 50 + 50}%`,
    }">
      <GridBase b50 :style="{ width: fw, transform: `translateX(-${pv * 50}%)` }" />
    </div>
    <div class="bg" v-else-if="video" :style="{
      marginRight: `${pv * 50}%`,
      width: `${(1 - pv) * 50 + 50}%`,
    }">
      <video v-if="video" :src="video" muted autoplay loop playsinline b50 :style="{ width: fw, transform: `translateX(-${pv * 50}%)` }" />
    </div>
    <template v-if="type === 'type1'">
      <div pr-split-cover class="hidden-lg-up">
        <div data-p="0.2,0.5" data-ph="0,100">
          <div pr-split-title v-if="title" :style="{ top: mid }">
            <div pr-split-title-wrap>
              {{ title }}
            </div>
          </div>
        </div>
        <div data-p="0.2,0.4" data-ph="0,100">
          <div pr-split-title v-if="title" :style="{ top: mid }">
            <div pr-split-title-wrap>
              {{ title }}
            </div>
          </div>
        </div>
      </div>
      <div pr-split-cover class="hidden-md-down">
        <div data-p="0.16,0.5" data-ph="0,100"></div>
        <div data-p="0.14,0.45" data-ph="0,100">
          <div pr-split-title v-if="title" :style="{ top: mid }">
            <div pr-split-title-wrap>
              {{ title }}
            </div>
          </div>
        </div>
        <div data-p="0.12,0.4" data-ph="0,100">
          <div pr-split-title v-if="title" :style="{ top: mid }">
            <div pr-split-title-wrap>
              {{ title }}
            </div>
          </div>
        </div>
        <div data-p="0.1,0.35" data-ph="0,100"></div>
      </div>
    </template>

    <template v-if="type === 'type0'"> </template>

    <template v-if="type === 'type2'">
      <div pr-split-cover>
        <div data-p="0.4,0.7" data-ph="0,100"></div>
        <div data-p="0.4,0.6" data-ph="0,100"></div>
      </div>
    </template>

    <template v-if="type === 'type3'">
      <div pr-split-cover class="hidden-md-up">
        <div data-p="0.4,0.6" data-ph="20,0"></div>
        <div data-p="0.4,0.7" data-ph="20,0"></div>
      </div>
      <div pr-split-cover class="hidden-sm-down">
        <div data-p="0.2,0.6" data-ph="36,50"></div>
        <div data-p="0.22,0.62" data-ph="24,50"></div>
        <div data-p="0.24,0.64" data-ph="12,50"></div>
        <div data-p="0.26,0.66" data-ph="0,50"></div>

        <div data-p="0.2,0.6" data-ph="13,0"></div>
        <div data-p="0.22,0.62" data-ph="26,0"></div>
        <div data-p="0.24,0.64" data-ph="39,0"></div>
        <div data-p="0.26,0.66" data-ph="52,0"></div>
      </div>
    </template>

    <template v-if="type === 'type4'">
      <div pr-split-cover class="hidden-md-up">
        <div data-p="0.75,0.9" data-ph="0,50"></div>
        <div data-p="0.65,0.8" data-ph="0,50"></div>
        <div data-p="0.75,0.9" data-ph="50,0"></div>
        <div data-p="0.65,0.8" data-ph="50,0"></div>
      </div>
      <div pr-split-cover class="hidden-sm-down">
        <div data-p="0.7,0.9" data-ph="0,50"></div>
        <div data-p="0.65,0.85" data-ph="0,50"></div>
        <div data-p="0.6,0.8" data-ph="0,50"></div>
        <div data-p="0.55,0.75" data-ph="0,50"></div>

        <div data-p="0.7,0.9" data-ph="50,0"></div>
        <div data-p="0.65,0.85" data-ph="50,0"></div>
        <div data-p="0.6,0.8" data-ph="50,0"></div>
        <div data-p="0.55,0.75" data-ph="50,0"></div>
      </div>
    </template>
    <div class="bg2" :style="{ marginRight: `${pv * 50}%`, width: `${(1 - pv) * 50 + 50}%` }">
      <slot />
      <div pr-split-title v-if="title" :style="{ top: mid, opacity: 1 - (pv * 15) }">
        <div pr-split-title-wrap>
          {{ title }}
        </div>
        <div pr-split-desc-wrap>
          {{ desc }}
        </div>
      </div>
      <div pr-split-title v-if="subTitle" :style="{ top: mid, opacity: pv }">
        <div pr-split-subtitle-wrap>
          {{ subTitle }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { applyRatio, getOffsetTop } from "@/utils";
import responsive from "@/utils/responsive";
import GridBase from "@/views/components/GridBase";

export default {
  name: "PrSplitLeft",
  components: { GridBase },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    video: { type: String },
    img: { type: String },
    push: { type: Number, default: 0 },
    type: { default: "type1" },
    bottomFree: { type: Boolean, default: false },
    alpha50: { type: Boolean, default: true },
    overflowTitle: { type: Boolean, default: false },
  },
  data() {
    return {
      innerList: [],
      fixed: false,
      mid: "10000000px",
      fw: "100vw",
    };
  },
  computed: {
    pv() {
      if (this.type === "type2") {
        return this.sect === "sm" ? 0.4 : 1;
      }
      const push = this.push * 2;
      return push < 0 ? 0 : push > 1 ? 1 : push;
    },
  },
  watch: {
    sv: "render",
  },
  methods: {
    inner(r) {
      applyRatio(this.innerList, r);
    },
    render() {
      if (!this.$el) return;
      this.fw = this.$el.offsetWidth + "px";
      if (this.onFix) {
        applyRatio(0);
        return;
      }
      const sv = this.sv;
      let d = getOffsetTop(this.$el) - sv;
      const h = window.innerHeight;
      if (d < 0) d = 0;
      this.inner(d / h);
      this.mid = this.$el.offsetHeight * 0.5 + "px";
    },
  },
  mounted() {
    this.innerList = this.$el.querySelectorAll("[data-p]");
    responsive.addListener(this.render);
  },
  beforeDestroy() {
    responsive.removeListener(this.render);
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

[pr-split-left] {
  .abs;
  .t(0);
  .l(0);
  .r(0);
  .h(100vh);

  [pr-split-title] {
    .fs(38, 52, -1.5);
    .semi-bold;
    .ls(0);
    .abs;
    .tc;
    .wf;
    .l(0);
    transform: translateY(-50%);
    color: #fff;
    white-space: pre-wrap;
    [pr-split-title-wrap] {
      .w(50%);
      .mh-c;
    }
    [pr-split-desc-wrap] {
      .mh-c;
      .mt(20);
      .p(0, 20);
      .fs(20, 30, -1);
    }
    [pr-split-subtitle-wrap] {
      .p(0, 48);
    }
  }

  .bg {
    .cover;
    .bg-c;
    .hf;
    .rel;
    overflow: hidden;

    video {
      .h(100%);
      object-fit: cover;
    }
  }

  .bg2 {
    .abs;
    .lt;
    .hf;
    .wf;

    [pr-split-title] {
      color: #fff;
    }
  }

  [pr-split-cover] {
    .hf;
    .wf;
    .abs;
    .lt;

    &:before {
      .cnt;
      .abs;
      .block;
      .wh(100%, 2);
      .lt(0, -1);
      background: #191919;
    }

    &:after {
      .cnt;
      .abs;
      .block;
      .wh(100%, 2);
      .lb(0, -1);
      background: #191919;
    }

    >div {
      .w(50%);
      .abs;
      .lt;
      .hf;
      background: #191919;
      overflow: hidden;
      .-box;
    }
  }

  [grid-base] {
    .hf;
    .wf;
    .abs;
    .lt;
  }

  @media (min-width: @screen-md-min) {
    [pr-split-title] {
      .fs(34, 46, -1.5);
      [pr-split-title-wrap] {
        .w(300px);
      }
      [pr-split-desc-wrap] {
        .w(510);
        .p(0);
        .fs(16, 26, -0.5);
      }
    }
  }

  @media (min-width: @screen-lg-min) {
    [pr-split-title] {
      .fs(38, 50, -1.5);
      [pr-split-title-wrap] {
        .w(345px);
      }
      [pr-split-desc-wrap] {
        .w(620);
        .mt(30);
        .fs(18, 28, -1);
      }
      [pr-split-subtitle-wrap] {
        .p(0, 120);
      }
    }
  }

  @media (min-width: @screen-xxl-min) {
    [pr-split-title] {
      .fs(68, 84, -2);
      [pr-split-title-wrap] {
        .w(800px);
      }
      [pr-split-desc-wrap] {
        .w(810);
        .mt(50);
        .fs(24, 38, -1.5);
      }
      [pr-split-subtitle-wrap] {
        .p(0, 80);
      }
    }
  }

  &.bottom-free {
    [pr-split-cover] {
      &:after {
        .hide;
      }
    }
  }

  &.type1 {
    [pr-split-cover] {
      >div {
        [pr-split-title] {
          .w(200%);
        }
      }

      >div+div {
        .l(50%);
        .-l(rgba(224, 224, 224, 0.1));

        [pr-split-title] {
          left: auto;
          right: 1px;
        }
      }
    }

    @media (min-width: @screen-lg-min) {
      [pr-split-cover] {
        >div {
          .w(25%);
        }

        >div+div {
          .l(25%);

          [pr-split-title] {
            left: 0;
            right: auto;
          }
        }

        >div+div+div {
          .l(50%);
          .-r(rgba(224, 224, 224, 0.1));

          [pr-split-title] {
            left: auto;
            right: 1px;
          }
        }

        >div+div+div+div {
          .l(75%);
          .-l;
        }
      }
    }
  }

  &.type2 {
    .bg {
      .ml(20%);
      .w(80%);
    }

    [pr-split-cover] {
      >div {
        .lb;
      }

      >div+div {
        .lt(50%, 0);
        .-l(rgba(224, 224, 224, 0.1));
      }
    }

    @media (min-width: @screen-md-min) {
      [pr-split-cover] {
        >div {
          .w(25%);
          .l(50%);
          .-l(rgba(224, 224, 224, 0.1));
        }

        >div+div {
          .l(75%);
          .-l;
        }
      }
    }

    @media (min-width: @screen-lg-min) {
      [pr-split-cover] {
        >div+div {
          .-l(rgba(224, 224, 224, 0.1));
        }
      }
    }
  }

  &.type3 {
    [pr-split-cover] {
      >div+div {
        .lb(50%, 0);
      }
    }

    @media (min-width: @screen-md-min) {
      [pr-split-cover] {
        >div {
          .w(25%);
        }

        >div+div {
          .lt;
        }

        >div:nth-child(n + 5) {
          .lb;
        }

        >div:nth-child(4n + 1) {
          .l(0);
        }

        >div:nth-child(4n + 2) {
          .l(25%);
          .-l(#191919);
        }

        >div:nth-child(4n + 3) {
          .l(50%);
          .-l(#2b2b2b);
        }

        >div:nth-child(4n + 4) {
          .l(75%);
          .-l(#191919);
        }
      }
    }

    @media (min-width: @screen-lg-min) {
      [pr-split-cover] {
        >div:nth-child(4n + 2) {
          .-l(#2b2b2b);
        }

        >div:nth-child(4n + 3) {
          .-r(#2b2b2b);
        }
      }
    }
  }

  &.type4 {
    [pr-split-cover] {
      >div:nth-child(n + 3) {
        .lb;
      }

      >div:nth-child(2n + 1) {
        .l(0);
      }

      >div:nth-child(2n + 2) {
        .l(50%);
        .-l(#2b2b2b);
      }
    }

    @media (min-width: @screen-md-min) {
      [pr-split-cover] {
        >div {
          .w(25%);
        }

        >div:nth-child(n + 3) {
          .lt;
        }

        >div:nth-child(n + 5) {
          .lb;
        }

        >div:nth-child(4n + 1) {
          .l(0);
        }

        >div:nth-child(4n + 2) {
          .l(25%);
          .-l(#191919);
        }

        >div:nth-child(4n + 3) {
          .l(50%);
          .-l(#2b2b2b);
        }

        >div:nth-child(4n + 4) {
          .l(75%);
          .-l(#191919);
        }
      }
    }

    @media (min-width: @screen-lg-min) {
      [pr-split-cover] {
        >div:nth-child(4n + 2) {
          .-l(#2b2b2b);
        }

        >div:nth-child(4n + 3) {
          .-r(#2b2b2b);
        }
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [pr-split-left] {
    &.split-title-hide {
      [pr-split-title] {
        opacity: 0;
      }
    }
  }
  
  .en & {
    [pr-split-left] {
      [pr-split-title] {
        .fs(44, 40, -1.5);
        .medium;
        [pr-split-title-wrap] {
          .w(398px);
        }
        [pr-split-desc-wrap] {
          .w(618);
          .mt(30);
          .fs(22, 28, -1);
          .medium;
        }
      }
    }  
  }

  @media (min-width: @screen-xxl-min) {
    .en & {
      [pr-split-left] {
        [pr-split-title] {
          .fs(64, 70, -2);
          [pr-split-title-wrap] {
            .w(800px);
          }
          [pr-split-desc-wrap] {
            .w(810);
            .mt(50);
            .fs(28, 36, -1.5);
          }
          [pr-split-subtitle-wrap] {
            .p(0, 80);
          }
        }
      }
    }
  }
}

</style>
